export default {
  enabled: false,
  fetchUrl: 'http://localhost:5000/login',
  secretKey: 'secretKey',
};
